<template>
    <div>
      <slot :data="cData" :loading="loading" :empty="empty"></slot>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <!-- <div slot="spinner">Loading...</div> -->
        <error-message slot="no-more" :text="text" />
        <div class="empty-bg" slot="no-results">
          <div class="box">
            <img src="@/assets/shopping-icon/empty.png" alt="" v-if="emptyimg">
            <img src="@/assets/shopping-icon/empty-bg.png" alt="" v-else/>
            <p>{{ text2 }}</p>
          </div>
        </div>
        <!-- <error-message slot="no-results" /> -->
      </infinite-loading>
    </div>
  </template>
  
  <script type="text/javascript">
  import InfiniteLoading from "vue-infinite-loading";
  export default {
    name: "ticket-scroll",
    data() {
      return {
        height: 0,
        page: 1,
        data: [],
        loading: 0,
        infiniteId: 1,
        btnFlag: false,
      };
    },
    //返回时要修改
    props: {
      limit: {
        type: Number,
        default: 10,
      },
      url: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        default() {
          return {};
        },
      },
      text: {
        type: String,
        default: '主人，没有更多啦~'
      },
      text2: {
        type: String,
        default: '主人，暂无券哦~'
      },
      emptyimg: {
        type: Boolean,
        default: false
      },
      computeData: Function,
    },
    computed: {
      sendData() {
        return {
          ...this.params,
          page: this.page,
          limit: this.limit,
        };
      },
      trigger() {
        return this.url + "?" + this.$QueryString.stringify(this.params);
      },
      cData() {
        return (
          (typeof this.computeData === "function"
            ? this.computeData(this.data)
            : this.data) || []
        );
      },
      empty() {
        return !this.cData.length;
      },
    },
  
    created() {},
    mounted() {},
    methods: {
      infiniteHandler($state) {
        // this.data = [
        //   {
        //     roll_id: "1",
        //     create_time: "2023-03-10 14:46:35",
        //     expire_time: "2023-07-28 13:50:53",
        //     deduction_price: "1.00",
        //     rule: "抽奖抵扣卷",
        //     roll_name: "通用抽奖卷",
        //     type: "1",
        //     is_use: "0",
        //     roll_flag: 1,
        //     valid_time: "2023/03/10-2023/07/28",
        //   },
        //   {
        //     roll_id: "2",
        //     create_time: "2023-03-10 14:48:45",
        //     expire_time: "2023-06-01 13:50:53",
        //     deduction_price: "1.00",
        //     rule: "抽奖抵扣卷",
        //     roll_name: "黄金抽奖卷",
        //     type: "1",
        //     is_use: "1",
        //     roll_flag: 3,
        //     valid_time: "2023/03/10-2023/06/01",
        //   },
        //   {
        //     roll_id: "3",
        //     create_time: "2023-03-10 14:46:35",
        //     expire_time: "2023-06-02 13:50:53",
        //     deduction_price: "1.00",
        //     rule: "抽奖抵扣卷",
        //     roll_name: "白银抽奖卷",
        //     type: "1",
        //     is_use: "0",
        //     roll_flag: 2,
        //     valid_time: "2023/03/10-2023/06/02",
        //   },
        //   {
        //     roll_id: "4",
        //     create_time: "2023-03-10 14:46:35",
        //     expire_time: "2023-07-30 13:50:53",
        //     deduction_price: "1.00",
        //     rule: "抽奖抵扣卷",
        //     roll_name: "钻石抽奖卷",
        //     type: "1",
        //     is_use: "0",
        //     roll_flag: 1,
        //     valid_time: "2023/03/10-2023/07/30",
        //   },
        // ];
        // $state.complete();
        // return;
        if (this.url != "") {
          this.loading++;
          this.$Ajax(this.url, this.sendData)
            .then((rs) => {
              this.page++;
              this.$emit("on-fetch", {
                data: rs.data.list,
              });
              if (
                rs.code == 200 &&
                rs.data.list instanceof Array &&
                rs.data.list.length > 0
              ) {
                this.data.push(...rs.data.list);
                $state.loaded();
              }
              if (
                !rs.data.page_info.totalPage ||
                rs.data.page_info.page >= rs.data.page_info.totalPage
              ) {
                $state.complete();
              }
            })
            .finally(() => {
              //this.loading--;
            });
        }
      },
      refresh() {
        this.page = 1;
        this.data = [];
        this.infiniteId++;
      },
    },
    watch: {
      trigger: "refresh",
    },
    components: {
      InfiniteLoading,
    },
  };
  </script>
  
<style lang="less" scoped>
  .empty-bg {
    .box {
      margin: 3.25rem 4.1rem 0;
      opacity: 0.83;
      img {
        width: 100%;
        height: 100%;
      }
      p {
        text-align: center;
        opacity: 1;
        color: #000000;
      }
    }
  }
</style>